"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var pickers_1 = require("@material-ui/pickers");
var date_fns_1 = require("@date-io/date-fns");
var pickers_2 = require("@material-ui/pickers");
var DatePickerInput_1 = require("./DatePickerInput");
var en_AU_1 = require("date-fns/locale/en-AU");
var es_1 = require("date-fns/locale/es");
var zh_CN_1 = require("date-fns/locale/zh-CN");
var useWidgetContext_1 = require("../../../common/react/useWidgetContext");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
exports.DatePicker = function (_a) {
    var formData = _a.formData;
    var _b;
    var value = formData.value, rawErrors = formData.rawErrors;
    var _c = react_1.useState(false), isDatePickerOpen = _c[0], setDatePickerOpen = _c[1];
    var currentDateValue = null;
    if (value) {
        currentDateValue = new Date(value);
    }
    var _d = react_1.useState(currentDateValue), selectedDate = _d[0], setNewDate = _d[1];
    var _e = react_1.useState(null), errorMessage = _e[0], setErrorMessage = _e[1];
    var currentError = ((_b = rawErrors) === null || _b === void 0 ? void 0 : _b.length) > 0 && rawErrors[0];
    var toggleDatePicker = react_1.useCallback(function (value) { return setDatePickerOpen(value); }, [isDatePickerOpen]);
    var locales = {
        'zh-hk': zh_CN_1.default,
        'es-ar': es_1.default,
        'es-cl': es_1.default,
        'es-co': es_1.default,
        'es-pe': es_1.default,
    };
    var configuration = useWidgetContext_1.default().configuration;
    // TODO: split code and load locale based on environment language
    var locale = locales[configuration.dimensions.language] || en_AU_1.default;
    var handleDateChange = react_1.useCallback(function (selectedDate) {
        setErrorMessage(null);
        setNewDate(selectedDate);
    }, []);
    react_1.useEffect(function () {
        if (rawErrors !== undefined) {
            setErrorMessage(currentError);
        }
    }, [rawErrors]);
    return (<pickers_1.MuiPickersUtilsProvider locale={locale} utils={date_fns_1.default}>
      <pickers_2.KeyboardDatePicker clearable={true} open={isDatePickerOpen} onClose={function () { return toggleDatePicker(false); }} value={selectedDate} onChange={handleDateChange} minDate={new Date()} format="yyyy/MM/dd" TextFieldComponent={function (props) {
        return DatePickerInput_1.default({ props: props, formData: formData, toggleDatePicker: toggleDatePicker, errorMessage: errorMessage });
    }} okLabel={<Translation_1.default id="enquiryForm.datePicker.ok"/>} cancelLabel={<Translation_1.default id="enquiryForm.datePicker.cancel"/>} clearLabel={<Translation_1.default id="enquiryForm.datePicker.clear"/>}/>
    </pickers_1.MuiPickersUtilsProvider>);
};
exports.default = exports.DatePicker;
